import { UploadFailureReason } from '../../../../../../../backend/src/types/types';
import { UploadMetadata } from '@/api/types/backend-dto-types';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/molecules/table';
import formatDate from '@/helpers/formatDate';

interface UploadFailuresTableProps {
  upload: UploadMetadata;
}

const UploadFailuresTable = ({ upload }: UploadFailuresTableProps) => {
  const formatFailureReason = (reason: string) => {
    switch (reason) {
      case UploadFailureReason.Duplicate:
        return 'Duplicate File';
      case UploadFailureReason.UnsupportedFileFormat:
        return 'Unsupported File Type';
      default:
        return reason;
    }
  };

  const formatFailureDescription = (failure: any) => {
    if (failure.parentFile && failure.rejectedReason === UploadFailureReason.UnsupportedFileFormat) {
      return `Attachment '${failure.filename}' from email '${failure.parentFile.name}'`;
    }
    return failure.filename;
  };

  return (
    <div className="flex flex-col">
      {/* Fixed height container for consistent layout */}
      <div className="h-full min-h-96 overflow-y-auto rounded-md border border-gray-200 bg-white">
        {upload.uploadFailures && upload.uploadFailures.length > 0 ? (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>File Name</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Failure Reason</TableHead>
                <TableHead>Upload Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {upload.uploadFailures.map((failure) => (
                <TableRow key={failure.id}>
                  <TableCell className="font-medium">
                    <div className="max-w-md">
                      <div className="truncate">{formatFailureDescription(failure)}</div>
                      {failure.parentFile && (
                        <div className="mt-1 text-xs text-gray-500">Email attachment not supported</div>
                      )}
                    </div>
                  </TableCell>
                  <TableCell>{failure.extension?.toUpperCase() || 'Unknown'}</TableCell>
                  <TableCell>
                    <span className="rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-red-200">
                      {formatFailureReason(failure.rejectedReason)}
                    </span>
                  </TableCell>
                  <TableCell>{formatDate(failure.createdDate, true, true)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="flex h-full items-center justify-center">
            <p className="text-gray-500">No upload failures found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadFailuresTable;
